import { KEYS } from '../../../../../../l18n/constants';
import computeTagName from '../../../../../../utils/computeTagName';
import computeClassName from '../../../../../../utils/computeClassName';
import ChangeSearchLocationControl from './ChangeSearchLocationControl';
import { useL18nContext } from '../../../../ContextProvider/L18n';
import { usePartnerSearchContext } from '../../../../ContextProvider/Partner/Search';
import ProcessingIndicator from '../../../../ProcessingIndicator';
import Container from '../../../../Container';
import HeroText from './HeroText';

const constants = Object.freeze({
  TAG_DEFAULT: 'header',
  CLASSNAME_BASE: 'h-cc-60.5 sm:h-cc-81 bg-pf-hero-pattern bg-cover bg-no-repeat bg-right'
});

const propsDefaults = Object.freeze({
  tag: constants.TAG_DEFAULT
});

export default function PartnerSearchHeader(
  {
    tag = propsDefaults.tag,
    className = ''
  }
) {
  const {
    selectedCountryName,
    foundPartnerCount,
    isFilterLoadingInProgress,
    isPartnerSearchInProgress,
    isUserGeoLocationInProgress
  } = usePartnerSearchContext();
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  const translatedProcessingInProgressTitle = getTranslationFor(KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS);

  // HeroText className="mb-cc-3.5 xs:mb-6 sm:mb-10"
//
  return (
    <ComputedTagName className={computedClassName}>
      <Container className="flex flex-col items-center justify-center h-full pb-14">
        {
          (isFilterLoadingInProgress || isUserGeoLocationInProgress || isPartnerSearchInProgress) ?
            <ProcessingIndicator size="extralarge" title={translatedProcessingInProgressTitle}/> :
            <div className="flex flex-col items-center justify-between">
              <h1 className="font-extralight text-cc-300 sm:text-cc-400 text-cc-white text-center mb-4">Partner Locator</h1>

              <HeroText className=""
                        foundPartnerCount={foundPartnerCount}
                        selectedCountryName={selectedCountryName}/>
              <ChangeSearchLocationControl className="mt-5"/>
            </div>
        }
      </Container>
    </ComputedTagName>
  );
}
